import { render, staticRenderFns } from "./hotelinfo.vue?vue&type=template&id=382bde0f&scoped=true"
import script from "./hotelinfo.vue?vue&type=script&lang=js"
export * from "./hotelinfo.vue?vue&type=script&lang=js"
import style0 from "./hotelinfo.vue?vue&type=style&index=0&id=382bde0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bde0f",
  null
  
)

export default component.exports